import React from 'react';
import { FieldPropsContext } from '../../../../contexts/field-props-context';
import { useForm } from '../../../../contexts/form-context';
import { useExternalData } from '../../contexts/external-data-context';
import { useFormFields } from '../../contexts/form-fields-context';
export const ReadOnlyField = ({ field, FieldLayout })=>{
    const componentsById = useFormFields();
    const externalData = useExternalData();
    const form = useForm();
    const { requiredIndicator, requiredIndicatorPlacement } = form.requiredIndicatorProperties || {};
    const FieldComponent = componentsById[field.fieldType];
    if (!FieldComponent) {
        return null;
    }
    const fieldProps = {
        ...field.properties,
        id: field.id,
        externalData,
        fieldType: field.fieldType,
        FieldLayout,
        requiredIndicatorType: requiredIndicator,
        requiredIndicatorPlacement
    };
    return /*#__PURE__*/ React.createElement(FieldPropsContext.Provider, {
        value: {
            v2: fieldProps
        }
    }, /*#__PURE__*/ React.createElement(FieldComponent, fieldProps));
};

//# sourceMappingURL=read-only-field.js.map